@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'risk'"
        [moduleType]="moduleType"
        [idProp]="'guid'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [buttonConfig]="buttonConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onDblClick)="openDetail($event)"
        (onAddClick)="add()"
        (onServerFiltersApplied)="getData($event)"
    >
    </cerrix-workspace>
}
<add-new-risk-dialog [name]="'addNewRisk'" (onCreateNewRisk)="addRisk()"></add-new-risk-dialog>
<generate-ai-risks-dialog [name]="'generateAiRisks'"></generate-ai-risks-dialog>
